import axios from "axios";
import { getValidToken } from "../../../utils/authUtils";
import { ServiceLogFormData } from './serviceLog';

export const serviceLogService = {
    createServiceLog: async (data: ServiceLogFormData) => {
        try {
            const token = await getValidToken();
            const response = await axios.post(
                `${process.env.REACT_APP_API_HOST}vehicle-service/logs`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error creating service log:', error);
            throw error;
        }
    },

    getAllServiceLogs: async (filters?: any) => {
        const token = await getValidToken();
        const response = await axios.get(`${process.env.REACT_APP_API_HOST}vehicle-service/logs`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: filters,
        });
        return response.data;
    },

    getServiceLogById: async (id: string) => {
        const token = await getValidToken();
        const response = await axios.get(`${process.env.REACT_APP_API_HOST}vehicle-service/logs/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    updateServiceLog: async (logId: string, data: ServiceLogFormData) => {
        try {
            const token = await getValidToken();
            const response = await axios.put(
                `${process.env.REACT_APP_API_HOST}vehicle-service/logs/${logId}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error updating service log:', error);
            throw error;
        }
    },

    deleteServiceLog: async (id: string) => {
        const token = await getValidToken();
        await axios.delete(`${process.env.REACT_APP_API_HOST}vehicle-service/logs/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    },

    getServiceLogsByVehicle: async (vehicleId: string, filters?: any) => {
        const token = await getValidToken();
        const queryParams = new URLSearchParams({
            ...(filters?.serviceDate && { serviceDate: filters.serviceDate }),
            ...(filters?.serviceType && { serviceType: filters.serviceType }),
        });
        const response = await axios.get(
            `${process.env.REACT_APP_API_HOST}vehicle-service/logs/vehicle/${vehicleId}?${queryParams}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    },

    getServiceLog: async (logId: string) => {
        try {
            const token = await getValidToken();
            const response = await axios.get(`${process.env.REACT_APP_API_HOST}vehicle-service/logs/${logId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching service log:', error);
            throw error;
        }
    },
};

export const scheduleService = {
    getScheduleByVehicle: async (model: string) => {
        const token = await getValidToken();
        const response = await axios.get(`${process.env.REACT_APP_API_HOST}vehicle-service/checklist/vehicle/${model}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },
    getScheduleByVehicleAndOdometer: async (model: string, odometer: number) => {
        const token = await getValidToken();
        const response = await axios.get(`${process.env.REACT_APP_API_HOST}vehicle-service/checklist/${model}/${odometer}/schedule`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },
};